// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
}

.pagination__list {
  display: flex;
  align-items: center;
  gap: 6px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.pagination__btn {
  border: 1px solid #d0d7de;
  background: #fff;
  color: #24292f;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  border-radius: 0;
  white-space: nowrap;
}

.pagination__btn:hover:not(:disabled) {
  background: #f6f8fa;
}

.pagination__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination__btn.is-active {
  background: #046A38;
  border-color: #046A38;
  color: white;
  font-weight: 600;
}

.pagination__btn.is-active:hover {
  background: #046A38;
  border-color: #046A38;
  color: white;
  font-weight: 600;
}

.pagination__ellipsis {
  padding: 6px 8px;
  color: #57606a;
  -webkit-user-select: none;
          user-select: none;
}

.pagination__meta {
  color: #57606a;
  font-size: 13px;
}

.per-page-container{
  display: flex;
  align-items: center;
  gap: 8;
}

.pagination-container{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
}

.page-num{
    white-space: nowrap;
    color: #57606a;
    font-size: 13px;
}
@media only screen and (max-width: 767px) {
    .pagination-container{
	  flex-direction: column;
    }
    .pagination{
	  flex-direction: column;
    }
 
}`, "",{"version":3,"sources":["webpack://./src/styles/pagination.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;AACA;IACI;GACD,sBAAsB;IACrB;IACA;GACD,sBAAsB;IACrB;;AAEJ","sourcesContent":["\n.pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 8px 0;\n}\n\n.pagination__list {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.pagination__btn {\n  border: 1px solid #d0d7de;\n  background: #fff;\n  color: #24292f;\n  padding: 6px 10px;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.15s ease-in-out;\n  border-radius: 0;\n  white-space: nowrap;\n}\n\n.pagination__btn:hover:not(:disabled) {\n  background: #f6f8fa;\n}\n\n.pagination__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination__btn.is-active {\n  background: #046A38;\n  border-color: #046A38;\n  color: white;\n  font-weight: 600;\n}\n\n.pagination__btn.is-active:hover {\n  background: #046A38;\n  border-color: #046A38;\n  color: white;\n  font-weight: 600;\n}\n\n.pagination__ellipsis {\n  padding: 6px 8px;\n  color: #57606a;\n  user-select: none;\n}\n\n.pagination__meta {\n  color: #57606a;\n  font-size: 13px;\n}\n\n.per-page-container{\n  display: flex;\n  align-items: center;\n  gap: 8;\n}\n\n.pagination-container{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 auto;\n}\n\n.page-num{\n    white-space: nowrap;\n    color: #57606a;\n    font-size: 13px;\n}\n@media only screen and (max-width: 767px) {\n    .pagination-container{\n\t  flex-direction: column;\n    }\n    .pagination{\n\t  flex-direction: column;\n    }\n \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
